<div
  class="video-img-container {{ flexAlignment?.alignmentClass || '' }} clearfix"
>
  <div class="video-img-inner" (click)="playVideo()">
    <img
      class="play-btn"
      alt="play"
      tabIndex="0"
      role="button"
      src="/assets/icons/play-btn.svg"
    />

    <digital-platform-image
      [imageOverride]="sureVideoOverlay"
    ></digital-platform-image>
  </div>
</div>
